import { render } from "./DogInfoStepComponent.vue?vue&type=template&id=32b717ee&ts=true"
import script from "./DogInfoStepComponent.ts?vue&type=script&lang=ts"
export * from "./DogInfoStepComponent.ts?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__